<mat-form-field fxFlex="100%" appearance="outline">
  <mat-label>{{ isKioskProduct ? 'Unit/Space Number' : 'Unit'}}</mat-label>

  <ng-container *ngIf="!isKioskProduct">
    <input required [formControl]="insurableField" [matAutocomplete]="autoInsurable" data-testid="unit" matInput>
    <mat-autocomplete autoActiveFirstOption #autoInsurable="matAutocomplete" [displayWith]="displayFnInsurable">
      <mat-option data-testid="unit_option" *ngFor="let insurable of filteredInsurables$ | async" [value]="insurable">
        <span class="caption">{{ insurable.title || 'N/A' }}</span>
      </mat-option>
    </mat-autocomplete>
  </ng-container>

  <ng-container *ngIf="isKioskProduct">
    <input required [formControl]="insurableField" matInput>
  </ng-container>

  <span *ngIf="nonApplicableControl" matSuffix>
    <mat-checkbox
      [formControl]="nonApplicableControl"
      color="primary"
      labelPosition="after"
      class="checkbox-layout-custom"
      (click)="$event.stopPropagation()">
      N/A
    </mat-checkbox>
  </span>
  <button *ngIf="loader" class="text-secondary spinner" mat-icon-button matSuffix type="button">
    <mat-icon>loading</mat-icon>
  </button>
  <button *ngIf="!loader && insurableField.value && insurableField.enabled" mat-icon-button matSuffix (click)="reset()" type="button">
    <mat-icon>close</mat-icon>
  </button>
  <button *ngIf="!isKioskProduct && !loader && !insurableField.value && insurableField.enabled" class="text-secondary" mat-icon-button matSuffix type="button">
    <mat-icon>keyboard_arrow_down</mat-icon>
  </button>
  <mat-error *ngIf="insurableField.invalid">{{ insurableField | errorMsg:'Unit' }}</mat-error>
</mat-form-field>
